import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-cbse-disclosure',
  templateUrl: './cbse-disclosure.component.html',
  styleUrls: ['./cbse-disclosure.component.scss']
})
export class CbseDisclosureComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
